import React from 'react';
import PopOver from '../../components/deprecated/PopOver';
import PopOverContainer from '../../components/deprecated/PopOverContainer';
import type { TOCState } from './ConnectedTableOfContents';
import TableOfContents from './TableOfContents';

interface PostTOCPopOverProps {
  children: React.ReactNode;
  tocProps: TOCState;
}

const PostTOCPopOver = ({ children, tocProps }: PostTOCPopOverProps) => (
  // @ts-expect-error
  <PopOver
    popOver={
      tocProps.headers.length > 0 && (
        <PopOverContainer>
          <h4 className="post-toc-title">Table of Contents</h4>
          <TableOfContents {...tocProps} />
        </PopOverContainer>
      )
    }
    popOverPortal={document.querySelector('.app-root') || document.body}
    placement="left-start"
    responsivePlacement="bottom"
    trigger="hover"
  >
    {children}
  </PopOver>
);

export default PostTOCPopOver;
